export default __webpack_public_path__ + "static/media/selectSelectedLavander.8c0c1631.svg";